function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../scss/main.scss';

/*------------------------------------------------------------------
Main Scripts
------------------------------------------------------------------*/

// store the equalizers here
window.equalizers = [];
// Function to update all the equalizers
window.equalize = function () {
  window.equalizers.forEach(function (equalizer) {
    equalizer.update();
  });
};
import Equalizer from '@meteora-digital/equalizer';
import PageLoader from './utils/PageLoader';
import PageComponentLoader from './utils/PageComponentLoader';
import CustomSlider from './classes/custom-slider';
import './components/ProductModal';
import '../../../../app/client/scripts/pages/projects-holder';
import '../../../../app/client/scripts/pages/blog-holder';
import { pages } from './pages';
import { components } from './components';
(function ($) {
  var pageLoader = new PageLoader(pages);
  var cLoader = new PageComponentLoader(components);
  $(document).ready(function () {
    if (pages) {
      pageLoader.load();
    }
    if (components) {
      cLoader.load();
    }
  });
  window.$ = $;
})(jQuery);
document.addEventListener('DOMContentLoaded', function () {
  // find all equalizers
  var equalizers = document.querySelectorAll('[data-equalize]');

  // Loop through each equalizer and add it to the list of equalizers
  for (var i = 0; i < equalizers.length; i += 1) {
    var equalizer = new Equalizer(equalizers[i], {
      rows: false
    });
    window.equalizers.push(equalizer);
  }
  _toConsumableArray(document.querySelectorAll('.js-gallery-slider')).forEach(function (section) {
    // The banner slider
    var slider = new CustomSlider(section, {
      nav: false,
      // mode: 'gallery',
      controls: true,
      gutter: 40
    });
  });
});